module.exports = __webpack_public_path__ + "646f9612927ab7b9ce865b94d829a39e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/recycle.svg
// module id = 776
// module chunks = 0